const ARTISTS = [
  { src: "/marketing/artist-dave-east.webp", name: "Dave East" },
  { src: "/marketing/artist-benny.webp", name: "Benny the Butcher" },
  { src: "/marketing/artist-ransom.webp", name: "Ransom" },
];

const TILTS = ["row-span-2 -rotate-2", "rotate-2", "-rotate-1"];

export default function ArtistBand() {
  return (
    <section
      id="artists-first"
      className="relative overflow-hidden [background:linear-gradient(to_bottom,#050B2D_0,rgba(5,11,45,0)_96px),radial-gradient(circle_at_85%_15%,rgba(255,79,154,0.34),transparent_26%),radial-gradient(circle_at_12%_85%,rgba(37,217,207,0.2),transparent_24%),#050B2D] px-[6vw] py-[88px] text-white before:absolute before:inset-0 before:opacity-[0.22] before:content-[''] before:[background-image:radial-gradient(rgba(255,255,255,0.7)_0.8px,transparent_0.8px)] before:[background-size:18px_18px] before:[mask-image:linear-gradient(90deg,black,transparent_58%)] max-[680px]:px-5 max-[680px]:py-[72px]"
    >
      <div className="relative z-[1] mx-auto grid w-[min(1180px,100%)] grid-cols-[1.05fr_0.95fr] items-center gap-[70px] max-[980px]:grid-cols-1">
        <div
          aria-label="Artists on Lutely"
          className="grid min-h-[440px] grid-cols-[1.18fr_0.82fr] grid-rows-2 gap-[14px] max-[980px]:max-w-[720px] max-[680px]:min-h-[380px] max-[680px]:gap-[9px]"
        >
          {ARTISTS.map((artist, i) => (
            <figure
              key={artist.name}
              className={`m-0 overflow-hidden rounded-[24px] border-[5px] border-white/90 shadow-[0_26px_70px_rgba(0,0,0,0.36)] ${TILTS[i]}`}
            >
              <img
                src={artist.src}
                alt={artist.name}
                loading="lazy"
                className="size-full object-cover"
              />
            </figure>
          ))}
        </div>
        <div>
          <p className="mb-[18px] -rotate-2 font-permanent-marker text-[28px] leading-[1.1] text-teal-500">
            Artists first
          </p>
          <h2 className="m-0 font-figtree text-[clamp(42px,5vw,68px)] font-black uppercase leading-none tracking-[-0.05em]">
            Reinventing how music moves.
          </h2>
          <p className="mt-6 max-w-[580px] font-open-sans text-[19px] leading-[1.55] text-white/[0.72]">
            The landscape is changing. Stay in control of your music, your
            releases, and the business you build. Lutely gives you the tools to
            grow your catalog and move forward on your own terms.
          </p>
        </div>
      </div>
    </section>
  );
}
